<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        <v-toolbar dense flat color="white">
                            <v-toolbar-title>Caricamento File XML</v-toolbar-title>
                        </v-toolbar>
                    </v-card-title>
                    <v-card-text>
                        <vue-dropzone :key="uploadSession" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :useCustomSlot=true :duplicateCheck="true" v-on:vdropzone-sending="sendingEvent">
                            <div class="dropzone-custom-content">
                                <h3 class="dropzone-custom-title">Trascina qui i file XML o ZIP</h3>
                                <div class="subtitle">oppure selezionali dal tuo computer</div>
                            </div>
                        </vue-dropzone>
                    </v-card-text>
                    <v-card-text style="height: 100px; position: relative">
                        <v-fab-transition>
                            <v-btn
                                    color="primary"
                                    dark
                                    absolute
                                    bottom
                                    right
                                    fab
                                    @click="importUploaded"
                            >
                                <v-icon>cloud_upload</v-icon>
                            </v-btn>
                        </v-fab-transition>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="uploadCompleteDialog" max-width="510" :fullscreen="$vuetify.breakpoint.smAndDown">
            <v-card>
                <v-card-title class="headline">Caricamento Fatture da XML</v-card-title>
                <v-card-text>
                    Documenti elaborati: {{importedInvoices}}
                    <br/>
                    Il caricamento è terminato, le fatture sono ora caricate nella sezione "Bozze".
                    <br/>
                    Per procedere all'invio allo SDI, aprire le bozze ed effettuare l'invio dopo aver verificato i dati.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat="flat" @click="uploadCompleteDialog=false">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import InvoiceApi from '@/api/invoices';
    export default {
        name: 'UploadInvoice',
        data() {
            return {
                dropzoneOptions: {
                    url: window.location.protocol+"//"+window.location.hostname+'/api/v1/auth/documents/upload',
                    maxFilesize: 5,
                    autoProcessQueue: true,
                    dictDefaultMessage: "<i class='fa fas-cloud-upload'></i>Carica Fatture XML o ZIP",
                    withCredentials: true,
                },
                uploadSession: '',
                importedInvoices: 0,
                uploadCompleteDialog: false,
            }
        },
        computed: {},
        methods: {
            importUploaded () {
                this.importedInvoices = 0;
                InvoiceApi.importUploaded(this.uploadSession)
                    .then((t) => {
                        this.importedInvoices = t.data.count;
                        this.uploadCompleteDialog = true;
                    })
                    .catch(t => {
                        this.$root.showBottomError(t.response.data, true);
                    })
                    .finally(()=> {
                        this.uploadSession = this.uuidv4();
                    });
            },
            uuidv4() {
                return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
            },
            sendingEvent (file, xhr, formData) {
                formData.append('uploadSession', this.uploadSession);
            }
        },
        mounted: function () {
            this.uploadSession = this.uuidv4();
            console.log(this.uploadSession);
        }

    }
</script>
